var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.198,
    height: 17.192,
    viewBox: "0 0 17.198 17.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-usuario",
    transform: "translate(0 0.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_723",
    "data-name": "Grupo 723",
    transform: "translate(0 -0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1287",
    "data-name": "Caminho 1287",
    d: "M0,9.1V8.093a1.391,1.391,0,0,0,.029-.161A8.177,8.177,0,0,1,.508,5.677a8.6,8.6,0,0,1,16.535,4.532,8.445,8.445,0,0,1-2.333,4.427,8.385,8.385,0,0,1-4.631,2.424c-.324.056-.652.089-.978.132H8.093c-.227-.027-.454-.05-.68-.082a8.4,8.4,0,0,1-4.477-2.049,8.413,8.413,0,0,1-2.8-4.985C.076,9.753.043,9.426,0,9.1m14.328,4.428A7.569,7.569,0,0,0,3.045,3.44a7.508,7.508,0,0,0-.18,10.09A5.964,5.964,0,0,1,6.55,9.44a3.625,3.625,0,1,1,4.607-5.558,3.65,3.65,0,0,1-.512,5.553,5.977,5.977,0,0,1,3.682,4.093m-5.67,2.656c.166-.008.389-.018.613-.032.1-.007.2-.023.3-.036a7.485,7.485,0,0,0,3.813-1.645.2.2,0,0,0,.061-.15,4.892,4.892,0,0,0-9.691-.01.209.209,0,0,0,.063.164,7.6,7.6,0,0,0,4.842,1.709M8.594,9.048a2.609,2.609,0,1,0-2.609-2.6,2.618,2.618,0,0,0,2.609,2.6",
    transform: "translate(0 0.208)",
    fill: "#292828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUsuario);
export default __webpack_public_path__ + "static/media/menu-usuario.ea7f40154acf0f950f065ef61c21da9b.svg";
export { ForwardRef as ReactComponent };